export const teams = [
    {
        id: 1,
        img: "person1",
        title: "VERKÄUFER JACOB",
    },

    {
        id: "2",
        img: "person2",
        title: "MARKETING MANAGER JANE",
    },

    {
        id: "3",
        img: "person3",
        title: "SALES MANAGER JOHN",
    },
];